/**
 * Parses a menu item object and returns Gatsby-field URI.
 *
 * @param {object} menuItem a single menu item
 * @param wordPressUrl
 * @param blogURI
 */
export const normalizeLocalLink = (url, wordPressUrl = "") => {
  if (!url || url === "#") {
    return null;
  }

  const configuredOrigin = wordPressUrl || process.env.WORDPRESS_URL || "";
  const origins = [configuredOrigin].filter(Boolean).flatMap(origin => {
    try {
      const parsed = new URL(origin);
      const host = parsed.host;

      return [
        origin.replace(/\/$/, ""),
        `${parsed.protocol}//${parsed.hostname}`,
        host ? `${parsed.protocol}//${host}` : null,
        `http://${parsed.hostname}`,
        `https://${parsed.hostname}`,
        host ? `http://${host}` : null,
        host ? `https://${host}` : null
      ].filter(Boolean);
    } catch (error) {
      return [origin.replace(/\/$/, "")];
    }
  });

  const normalizedUrl = origins.reduce((value, origin) => {
    if (value === origin) {
      return "/";
    }

    if (value.startsWith(`${origin}/`)) {
      return value.slice(origin.length);
    }

    return value;
  }, url);

  return normalizedUrl.replace(/https?:\/\/[^/]+/i, "");
};

export const CreateLocalLink = (menuItem, wordPressUrl, blogURI = "blog/") => {
  const { url, connectedObject } = menuItem;

  let newUri = normalizeLocalLink(url, wordPressUrl);

  /**
   * If it's a blog link, respect the users blogURI setting.
   */
  if (connectedObject && connectedObject.__typename === "WPGraphQL_Post") {
    newUri = blogURI + newUri;
  }

  return newUri;
};
